<template>
  <footer class="invoice-create-footer">
    <div class="invoice-create-footer-right payment-receipt-create-footer-right">
      <button type="button" class="app-header-btn app-header-btn--primary" :disabled="submitting" @click="$emit('submit')">
        {{ text.create.ui.footerActions.submit }}
      </button>
    </div>
  </footer>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: expenseReceiptsText } = useDomainText('expenseReceipts');

export default {
  name: 'ExpenseReceiptCreateFooterActions',
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  data() {
    return {
      text: expenseReceiptsText,
    };
  },
};
</script>

<style scoped>
.payment-receipt-create-footer-right {
  width: 100%;
  justify-content: flex-end;
}
</style>
